/* eslint-disable @typescript-eslint/no-unsafe-return */
import { builds } from '@saucelabs/sl-util-axios';

export interface GetBuildByNameProps {
  cloudType: string;
  name: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getBuildByName = ({ cloudType, name }: GetBuildByNameProps): any => (
  builds.get(`/${cloudType}/?name=${name}`)
    .then((response) => response.data)
    .catch(() => null)
);
